// extracted by mini-css-extract-plugin
export default {"referralBanner":"ReferralBanner_referralBanner__gn4IY","active":"ReferralBanner_active__BIZ+I"};